import type { FunctionComponent } from 'react';

import { BreakpointProvider } from '@/core/tamagoshi/MediaQuery/MediaQuery';
import { ProgrammaticAdviceReco } from '@/digitalAdvice/Recommendation/components/ProgrammaticAdviceReco/ProgrammaticAdviceReco';
import type {
  ProgrammaticAdviceRecoLevel,
  ProgrammaticAdviceRecoProduct,
} from '@/digitalAdvice/Recommendation/ProgrammaticAdviceReco.model';

export interface ProgrammaticAdviceRecoContainerProps {
  categoryName: string | undefined;
  className?: string;
  products: [ProgrammaticAdviceRecoLevel, ProgrammaticAdviceRecoProduct][];
}

export const ProgrammaticAdviceRecoContainer: FunctionComponent<
  ProgrammaticAdviceRecoContainerProps
> = ({ categoryName, className, products }) =>
  products.length > 0 ? (
    <BreakpointProvider>
      <ProgrammaticAdviceReco
        categoryName={categoryName}
        className={className}
        products={products}
      />
    </BreakpointProvider>
  ) : null;

ProgrammaticAdviceRecoContainer.displayName = 'ProgrammaticAdviceRecoContainer';
